import { Record, RecordOf } from 'immutable';



export type VerificationCodeRequest = RecordOf<VerificationCodeRequestProperties>;


export interface VerificationCodeRequestProperties {
  verificationMethod: string;
  username: string;
}


export class VerificationCodeRequestFactory {
  static readonly create = Record<VerificationCodeRequestProperties>({
    verificationMethod: null,
    username: null
  });
}
